import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CountryService } from '@API/base/country.service';
import { AlarmEmitterComponent } from '@alarms/components/alarm-emitter/alarm-emitter.component';
import { IfPermissionsDirective } from '@shared/directives/if-permissions.directive';
import { AddAlertFbComponent } from '@shared/UI/elements-ui/add-alert-fb/add-alert-fb.component';
import { NavbarComponent } from '@shared/UI/elements-ui/navbar/navbar.component';
import { SideBarComponent } from '@shared/UI/elements-ui/sidebar/sidebar.component';
import { SideBarService } from '@shared/UI/elements-ui/sidebar/sidebar.service';
import { SessionService } from '@utils/services/session.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    AlarmEmitterComponent,
    NavbarComponent,
    SideBarComponent,
    AddAlertFbComponent,RouterOutlet,
    IfPermissionsDirective
  ],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  public sidebarController = inject(SideBarService);
  public sidebarStatus = this.sidebarController.toggleAside;
  private readonly _countryService = inject(CountryService);
  private readonly _sessionService = inject(SessionService);

  ngOnInit(): void {
    this._countryService.getCountries();
    this._requestNotificationPermissions();
  }

  public toggleSidebar(): void {
    this.sidebarController.setClosed();
  }

  private _requestNotificationPermissions() {
    if (!this._sessionService.user?.permissions?.find((permission) => permission.module === 'alarms')?.permissions.includes('view') &&
      this._sessionService.user?.type !== 'admin') {
      return;
    }
    if (Notification.permission === 'granted') {
      return;
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          return;
        }
      });
    }
  }

}
